export default "__VITE_ASSET__Bjy6VeHR__"